import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexService {

  constructor(private http: HttpClient) { }

  getIndexData() {
    return this.http.get('/api/site/indexData');
  }

  getGrabToday() {
    return this.http.get('/api/site/grabToday');
  }
}
